import { render, staticRenderFns } from "./FValidatorsInfo.vue?vue&type=template&id=3f45ae02&scoped=true&"
import script from "./FValidatorsInfo.vue?vue&type=script&lang=js&"
export * from "./FValidatorsInfo.vue?vue&type=script&lang=js&"
import style0 from "./FValidatorsInfo.vue?vue&type=style&index=0&id=3f45ae02&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f45ae02",
  null
  
)

export default component.exports